import logoLightProsa from '@/assets/images/logo-light-prosa.png';
import logoDarkProsa from '@/assets/images/logo-dark-prosa.png';
import iconeProsa from '@/assets/images/icone-prosa.png';
import iconeDarkProsa from '@/assets/images/icone-dark-prosa.png';
import iconeLightProsa from '@/assets/images/icone-light-prosa.png';
import LogoProsaSvg from '@/assets/images/logo-prosa.svg';
import type { BrandingConfig } from './types';

export const prosaBranding: BrandingConfig = {
  key: 'PROSA',
  companyName: 'ProsaZap',
  shortName: 'ProsaZap',
  titles: {
    admin: 'ProsaZap - Ambiente Administrativo',
    user: 'ProsaZap - Gestão de Atendimento',
  },
  logo: {
    light: logoLightProsa,
    dark: logoDarkProsa,
    svg: LogoProsaSvg,
    iconLight: iconeLightProsa,
    iconDark: iconeDarkProsa,
  },
  favicon: iconeLightProsa,
  themeColor: '#198653',
  // Um só ícone com `sizes: "any"`: a marca não tem o jogo de tamanhos que a
  // Whiz tem em `public/img/icons`. O navegador reescala.
  pwaIcons: [
    { src: iconeLightProsa, sizes: 'any', type: 'image/png', purpose: 'any maskable' },
  ],
  colors: {
    light: {
      primary: '#198653',
      primaryRgb: '25, 134, 83',
      success: '#2bab60',
      successHover: '#198653',
      loaderPrimary: '#198653',
      loaderSecondary: '#2bab60',
    },
    dark: {
      primary: '#1ea465',
      primaryRgb: '30, 164, 101',
      success: '#39c668',
      successHover: '#2bab60',
      loaderPrimary: '#1ea465',
      loaderSecondary: '#39c668',
    },
  },
  gradients: {
    primary: 'linear-gradient(135deg, #198653, #2bab60)',
    chatBubbleSent: {
      light: 'linear-gradient(90deg, #2bab609b, #198653)',
      dark: 'linear-gradient(90deg, #1ea465, #2bab60bb)',
    },
  },
  loginAssets: {
    backgroundImage: '',
    overlayGradient: 'linear-gradient(45deg, rgba(25, 134, 83, 0.85), rgba(43, 171, 96, 0.78))',
  },
  images: {
    emptyChat: '/img/celular_prosa.png',
    emptyChatTeam: '/img/celular_team_prosa.png',
    chatWallpaper: '/img/fundo_prosa.png',
    avatarFallback: '/img/empty_prosa.png',
    avatarFallbackGroup: '/img/empty_group_prosa.png',
    communicationEmpty: '/img/comunicacao_empty_prosa.gif',
  },
  texts: {
    loginFooterAdmin: '© {year} ProsaZap Admin. Acesso monitorado.',
    loginFooterUser: '© {year} ProsaZap. Todos os direitos reservados.',
    installAppButton: 'Instalar Aplicativo ProsaZap',
    loadingApp: 'Carregando ProsaZap...',
    welcomeChatTitle: 'Seja bem-vindo ao ProsaZap',
    welcomeChatText: 'O ProsaZap ajuda você a organizar, acompanhar e gerenciar seus atendimentos em um só lugar.',
  },
};
